<ngx-spinner bdColor="rgba(128, 128, 128, 0.8)"
              size="default"
              color="#2f9cf2"
              type="line-scale-pulse-out"
              [name]="spinnerName"
              [fullScreen]="true">
              <p style="color: white" >Loading employment history data... </p>
</ngx-spinner>

<h3>Employee Employment History:</h3>
<div *ngIf="employeeHistory.length > 0" class="p-mb-3">
  <ag-grid-angular
    style="height:180px;"
    class="ag-theme-alpine"
    [context]="context"
    [rowData]="employeeHistory"
    [columnDefs]="gridHeaders"
    [gridOptions]="gridOptions"
    rowSelection="single">
  </ag-grid-angular>
</div>

<div *ngIf="employeeHistory.length === 0" class="text-danger p-mb-3">
  <i class="fas fa-exclamation-circle p-mr-2" aria-hidden="true"></i>
  No employment history found for selected employee!
</div>